/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      patients {
        items {
          id
          userID
          memberID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      patients {
        items {
          id
          userID
          memberID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      patients {
        items {
          id
          userID
          memberID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createUserMember = /* GraphQL */ `
  mutation CreateUserMember(
    $input: CreateUserMemberInput!
    $condition: ModelUserMemberConditionInput
  ) {
    createUserMember(input: $input, condition: $condition) {
      id
      userID
      memberID
      user {
        id
        patients {
          nextToken
        }
        createdAt
        updatedAt
      }
      member {
        id
        title
        firstname
        lastname
        dob
        gender
        bpPatientId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateUserMember = /* GraphQL */ `
  mutation UpdateUserMember(
    $input: UpdateUserMemberInput!
    $condition: ModelUserMemberConditionInput
  ) {
    updateUserMember(input: $input, condition: $condition) {
      id
      userID
      memberID
      user {
        id
        patients {
          nextToken
        }
        createdAt
        updatedAt
      }
      member {
        id
        title
        firstname
        lastname
        dob
        gender
        bpPatientId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserMember = /* GraphQL */ `
  mutation DeleteUserMember(
    $input: DeleteUserMemberInput!
    $condition: ModelUserMemberConditionInput
  ) {
    deleteUserMember(input: $input, condition: $condition) {
      id
      userID
      memberID
      user {
        id
        patients {
          nextToken
        }
        createdAt
        updatedAt
      }
      member {
        id
        title
        firstname
        lastname
        dob
        gender
        bpPatientId
        users {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createPatient = /* GraphQL */ `
  mutation CreatePatient(
    $input: CreatePatientInput!
    $condition: ModelPatientConditionInput
  ) {
    createPatient(input: $input, condition: $condition) {
      id
      title
      firstname
      lastname
      dob
      gender
      bpPatientId
      users {
        items {
          id
          userID
          memberID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updatePatient = /* GraphQL */ `
  mutation UpdatePatient(
    $input: UpdatePatientInput!
    $condition: ModelPatientConditionInput
  ) {
    updatePatient(input: $input, condition: $condition) {
      id
      title
      firstname
      lastname
      dob
      gender
      bpPatientId
      users {
        items {
          id
          userID
          memberID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deletePatient = /* GraphQL */ `
  mutation DeletePatient(
    $input: DeletePatientInput!
    $condition: ModelPatientConditionInput
  ) {
    deletePatient(input: $input, condition: $condition) {
      id
      title
      firstname
      lastname
      dob
      gender
      bpPatientId
      users {
        items {
          id
          userID
          memberID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteAppointment = /* GraphQL */ `
  mutation DeleteAppointment(
    $input: DeleteAppointmentInput!
    $condition: ModelAppointmentConditionInput
  ) {
    deleteAppointment(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      bookedBy
      canceledBy
      patientID
      appointmentDate
      appointmentTime
    }
  }
`;
export const deleteComm = /* GraphQL */ `
  mutation DeleteComm(
    $input: DeleteCommInput!
    $condition: ModelCommConditionInput
  ) {
    deleteComm(input: $input, condition: $condition) {
      id
      name
      phone
      email
      message
      preferredMethod
      isFeedback
      forAppointment
      reply
      resolved
      createdAt
      updatedAt
    }
  }
`;
export const createAppointment = /* GraphQL */ `
  mutation CreateAppointment(
    $input: CreateAppointmentInput!
    $condition: ModelAppointmentConditionInput
  ) {
    createAppointment(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      bookedBy
      canceledBy
      patientID
      appointmentDate
      appointmentTime
    }
  }
`;
export const updateAppointment = /* GraphQL */ `
  mutation UpdateAppointment(
    $input: UpdateAppointmentInput!
    $condition: ModelAppointmentConditionInput
  ) {
    updateAppointment(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      bookedBy
      canceledBy
      patientID
      appointmentDate
      appointmentTime
    }
  }
`;
export const createComm = /* GraphQL */ `
  mutation CreateComm(
    $input: CreateCommInput!
    $condition: ModelCommConditionInput
  ) {
    createComm(input: $input, condition: $condition) {
      id
      name
      phone
      email
      message
      preferredMethod
      isFeedback
      forAppointment
      reply
      resolved
      createdAt
      updatedAt
    }
  }
`;
export const updateComm = /* GraphQL */ `
  mutation UpdateComm(
    $input: UpdateCommInput!
    $condition: ModelCommConditionInput
  ) {
    updateComm(input: $input, condition: $condition) {
      id
      name
      phone
      email
      message
      preferredMethod
      isFeedback
      forAppointment
      reply
      resolved
      createdAt
      updatedAt
    }
  }
`;
